import {CompetitionStatsPageRouteMetaDataModel} from "./competition-stats-page.route.meta-data.model";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";
import {PAGES} from "../../../../../core/consts";

export class CompetitionStatsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.stats,
      path: 'stats',
      componentImport: () => import("../components/competition-stats-page" /* webpackChunkName: "competition-stats-page" */),
      metadataType: CompetitionStatsPageRouteMetaDataModel
    });
  }
}
